package diana.soleil.design.iraniancanadienbazzar.core.model

import kotlinx.serialization.Serializable

/**
 * A community news item shown in the Home "News" carousel (Iranian-Canadian community stories,
 * platform announcements, cultural dates). Authored by admins (console or admin tools), localized
 * like all business content ([LocalizedText] + [Localizer]; see `docs/LOCALIZATION.md`).
 */
@Serializable
data class NewsArticle(
    val id: String,
    val title: LocalizedText = LocalizedText(),
    /** Short teaser for the card; falls back to the first lines of [body] when absent. */
    val summary: LocalizedText = LocalizedText(),
    val body: LocalizedText = LocalizedText(),
    val imageUrl: String? = null,
    /** Optional external "read more" URL (original source article). */
    val linkUrl: String? = null,
    /** Target metro (`gta`|`mtl`|`yvr`); null = shown in every metro (national/community-wide). */
    val metroId: String? = null,
    val publishedAtMillis: Long = 0L,
)
